import { useDispatch } from "react-redux";
import { CompItem } from "./styles";
import { CompSelectorInterface } from "../../types/competitionfilter";
import { sendAnalyticsEvent } from "../../utils/sendAnalyticMessages";

const CompSelector = ({
  competition,
  selection,
}: CompSelectorInterface) => {
  const dispatch = useDispatch();

  const parentURL = document.referrer
    ? document.referrer
    : window.location.ancestorOrigins?.[0];

  const handleCompClick = () => {
    dispatch({
      type: "ADD_COMPETITION_TO_SEARCH",
      payload: competition,
    });
    dispatch({
      type: "SET_SELECTED_FILTER",
      payload: '',
    });
    sendAnalyticsEvent(
      {
        event: "smart_picks_competition_select",
        selection: competition,
      },
      parentURL
    );
    dispatch({ type: "SET_DATE_FILTER", payload: '' });
    dispatch({ type: "SET_MARKET_FILTER", payload: '' });
    dispatch({ type: "SET_STATS_FILTER", payload: '' });
  };

  return (
    <CompItem
      onClick={() => handleCompClick()}
      selected={competition === selection[0]}
    >
      {competition}
    </CompItem>
  );
};

export default CompSelector;
